<template>
  <el-card class="h-full">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入单元名称"
          v-model="equipSearchData.search"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          filterable
          placeholder="请选择区域"
          v-model="equipSearchData.regionalLocation"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <department-select
          ref="departmentSelect"
          class="mr-10px !w-50 mb-10px"
          v-model="equipSearchData.responsibleDepartment"
        ></department-select>
        <el-button class="mb-10px" size="small" type="primary" @click="handleSearch()"
          >搜索</el-button
        >
        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button
          class="mb-10px"
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          class="mb-10px"
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >批量删除</el-button
        >
        <!-- <el-button
        size="small"
        @click="handleEvent(null, 'downloadTemplate')"
        :disabled="!$hasAccess('downloadTemplate')"
        >下载模板</el-button
      > -->
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >导入</el-button
        >
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'batchExport')"
          :disabled="!$hasAccess('batchExport')"
          >导出</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="equipDataList"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="equipTableLoading"
          @selection-change="handleSelectionEquip"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="风险分析单元名称"
            prop="unitName"
            width="260"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="风险分析单元类型"
            width="260"
            prop="unitType"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ riskAnalyssisUnitTypeMap(scope.row.unitType) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="危险源编码"
            prop="significantHazardCode"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="区域位置"
            prop="regionalLocationStr"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任部门"
            prop="responsibleDepartmentName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任人"
            prop="responsiblePersonName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="单元创建人"
            prop="creatorName"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="新增时间" prop="creationTime" width="260" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.creationTime
                  ? dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" fixed="right">
            <template slot-scope="scope">
              <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <equip-unit-form
      :FormData="FormData"
      @refreshList="
        formDialog = false
        getEquipList()
      "
      @cancel="formDialog = false"
      v-if="formDialog"
      :formProps="formProps"
    ></equip-unit-form>

    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { RiskAnalysisUnitApi } from '@wiz-api/double-prevention-management'
import { wizUploadFile } from '@wiz-core/compts'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import utils from '@/components/safety/enumField/utils'
import EquipUnitForm from '../components/RiskAnalysisTable/EquipUnitForm'

const areaApi = new AreaApi()
const riskAnalysisUnitApi = new RiskAnalysisUnitApi()

export default {
  name: 'equip-unit-table',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    EquipUnitForm,
    wizUploadFile,
    DepartmentSelect,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      riskAnalyssisUnitTypeList: [],
      FormData: {
        unitName: '',
        unitNumber: '',
        unitType: '',
        unitTypeList: [],
        isMajorDangerSource: true,
        significantHazardName: '',
        significantHazardCode: '',
        mayAccidentType: '',
        mayAccidentTypeList: [],
        regionalLocation: '',
        affiliationOrg: '',
        responsibleDepartment: '',
        responsiblePerson: '',
        riskCorrectiveFactors: null,
        groundCoordinates: '',
        remark: '',
      },
      formDialog: false,
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      departmentList: [],
      areaList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        search: '',
        responsibleDepartment: undefined,
        regionalLocation: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    this.getEquipList()
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.RiskAnalyssisUnitType'],
      ['riskAnalyssisUnitTypeList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
    riskAnalyssisUnitTypeMap() {
      return (val) => {
        return (
          this.riskAnalyssisUnitTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  methods: {
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.$refs.departmentSelect.userName = ''
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await riskAnalysisUnitApi.importFromExcelTemplateFile()
      if (!err) {
        this.downLoadExcel('风险分析单元', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await riskAnalysisUnitApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await riskAnalysisUnitApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await riskAnalysisUnitApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            if (this.FormData.mayAccidentType) {
              this.FormData.mayAccidentTypeList = this.FormData.mayAccidentType
                .split(',')
                .map((item) => {
                  return Number(item)
                })
            }
            this.initDialog(operation)
          }
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'batchExport':
          ;[err, res] = await riskAnalysisUnitApi.exportToExcelFile()
          if (!err) {
            this.downLoadExcel('风险分析单元数据', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await riskAnalysisUnitApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            if (this.FormData.mayAccidentType) {
              this.FormData.mayAccidentTypeList = this.FormData.mayAccidentType
                .split(',')
                .map((item) => {
                  return Number(item)
                })
            }
            this.initDialog(operation)
          }
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await riskAnalysisUnitApi.deleteMany({ ids: this.selectionEquipData })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.formDialog = true
      this.formProps.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await riskAnalysisUnitApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
